module.exports = {
      id: "business-usage",
      viewBox: "0 0 28.79 24.369",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#business",
      toString: function () {
        return this.url;
      }
    }